import { Link } from "react-router-dom";

const LEGAL_LINKS = [
  ["Terms & Conditions", "/terms-and-conditions"],
  ["Privacy Policy", "/privacy-policy"],
  ["Terms of Use", "/terms-of-use"],
];

export const Footer = () => (
  <footer
    className="relative z-10 border-t border-white/10 px-6 py-14 md:px-10"
    data-testid="site-footer"
  >
    <div className="mx-auto flex max-w-7xl flex-col gap-10">
      <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
        <span className="font-display text-base font-medium tracking-[0.3em] text-white">
          RADIATE
        </span>

        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
          {LEGAL_LINKS.map(([label, href]) => (
            <Link
              key={href}
              to={href}
              className="text-sm text-white/50 transition-colors hover:text-white"
              data-testid={`footer-link-${href.slice(1)}`}
            >
              {label}
            </Link>
          ))}
          <a
            href="mailto:info@radiateapp.com"
            className="text-sm text-white/50 transition-colors hover:text-white"
            data-testid="footer-contact"
          >
            Contact
          </a>
        </nav>
      </div>

      <p className="text-center text-xs text-white/35">
        © {new Date().getFullYear()} Radiate · MODERN MIND EARTH LLC. Regulate ·
        Rewire · Radiate.
      </p>
    </div>
  </footer>
);
